<template>
    <div class="marge">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">ETP业务系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>ETP合并</el-breadcrumb-item>
        </el-breadcrumb>

        <div style="float: left;margin-top: 20px">
            <el-autocomplete class="inline-input"
                             v-model="queryParams.coinType"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入币种">
                <i class="el-icon-close el-input__icon" slot="suffix"
                   @click="cleanSearchCoin" style="cursor:pointer;">
                </i>
            </el-autocomplete>

            <el-date-picker
                    v-model="dataArry"
                    type="datetimerange"
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="合并时间开始日期"
                    end-placeholder="合并时间结束日期">
            </el-date-picker>

            <el-button style="margin-left: 30px" type="primary" @click="searchData">搜索</el-button>
            <el-button style="margin-left: 30px" type="primary" @click="etpMargeDialog">ETP合并</el-button>
        </div>
        <div class="marge-list">
            <el-table class="marge-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="coinType" label="币种类型"></el-table-column>
                <el-table-column prop="mergeShare" label="合并份额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalBeforeMerge" label="合并前币总量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shizhiBeforeMerge" label="合并前市值余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalAfterMerge" label="合并后币总量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shizhiAfterMerge" label="合并后市值余额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalAfterDeposit" label="市值加币后总量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shizhiAfterDeposit" label="市值加币后余额" show-overflow-tooltip></el-table-column>
                <el-table-column label="合并时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.mergeTime | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog title="ETP合并" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="120px">
                <el-form-item label="币种">
                    <el-autocomplete class="inline-input"
                                     v-model="margeData.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanMargeCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="合并份额">
                    <el-input-number v-model="margeData.share" :min="0" :max="100000000" label="合并份额"></el-input-number>
                </el-form-item>
            </el-form>


            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="etpMarge">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'EtpMarge',
        data() {
            return {
                dataList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    coinType: "",
                    mergeTimeStart: "",
                    mergeTimeEnd: "",
                    page: 1,
                    size: 10
                },
                margeData: { //查询参数
                    coinType: "",
                    share: 0
                },
                dialogVisible: false, //对话框是否显示
                coinTypes: [],
                loading: false,
                dataArry: []
            };
        },
        methods: {
            searchData() {
                if (this.dataArry) {
                    this.queryParams.mergeTimeStart = this.dataArry[0];
                    this.queryParams.mergeTimeEnd = this.dataArry[1];
                } else {
                    this.queryParams.mergeTimeStart = null;
                    this.queryParams.mergeTimeEnd = null;
                }
                this.getEtpMargeList(this.queryParams);
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getEtpMargeList(query) {
                api.getEtpMargeList(query).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            etpMargeDialog() {
                this.dialogVisible = true;
            },
            etpMarge() {
                api.etpMerge(this.margeData).then(({data}) => {
                    this.$message.success('合并成功!');
                    this.getEtpMargeList(this.queryParams);
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getEtpMargeList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getEtpMargeList(this.queryParams);
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            cleanMargeCoin() {
                this.margeData.coinType = '';
            },
            clearData() {
                this.margeData = {
                    coinType: "",
                    share: 0
                }
                this.loading = false;
            }
        },
        created() {
            this.getEtpMargeList(this.queryParams);
            this.getAllSupportCoin();
        }
    };
</script>

<style lang="less" scoped>
    .marge {
        .marge-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .marge-table {
                margin-top: 30px;
            }
        }
    }
</style>

